import { createContext } from "react";

export const DeleteDialogContext = createContext();
